import { Dropdown } from '..';
import { useLanguageContext } from '../../hooks';

const defaultOptions: OptionType<LanguageType>[] = [
  { value: 'EN', label: 'EN' },
  { value: 'DE', label: 'DE' },
];

type LanguageSwitchProps = {
  options?: OptionType<LanguageType>[];
};

const Value: React.FC<{ value?: string }> = ({ value }) => {
  return <div className="pr-xl text-white">{value}</div>;
};

export const LanguageSwitch: React.FC<LanguageSwitchProps> = ({
  options = defaultOptions,
}) => {
  const { lang, setLang } = useLanguageContext();

  return (
    <div className="h-9 cursor-pointer mr-1">
      <Dropdown
        value={lang}
        options={options}
        onChange={setLang}
        wrapperClassName="gap-x-1"
        renderValue={({ value }) => <Value value={value} />}
      />
    </div>
  );
};
